import { createFileRoute } from '@tanstack/react-router';
import { CreateEventPage } from '../../features/events/wizard/CreateEventPage.jsx';

export const Route = createFileRoute('/_app/events/new')({ component: CreateEventPage });
